import { Navigate } from 'react-router-dom';

export function PppDetailPage() {
  return <Navigate to="/ppp" replace />;
}
